// extracted by mini-css-extract-plugin
export default {"bottom-toast":"gWdND_bottom-toast"};